import React from 'react';
import ServicePageLayout from '../../components/ServicePageLayout';
import { llcFormationData } from '../../data/serviceData';

const LLCFormation = () => {
  return <ServicePageLayout data={llcFormationData} />;
};

export default LLCFormation;
